/**
 * Matching for the filter-option search boxes.
 *
 * Lives apart from the components because the interesting part is not the
 * `includes()` — it is that Arabic has several ways to write the same word and
 * shoppers do not type the one the catalogue was entered with. A real category
 * on do-print is "آلبسة مهنية"; nobody reaches for the madda when searching,
 * so a naive substring match returns nothing and the filter looks broken.
 *
 * Client-safe on purpose: the filter sidebar is a client component.
 */

/** Combining marks: Arabic harakat/hamza forms, superscript alef, Latin accents. */
const COMBINING = /[ً-ٰٕ̀-ͯ]/g;
/** Kashida — decorative letter-stretching that carries no meaning. */
const TATWEEL = /ـ/g;
/** آ أ إ ٱ ٲ ٳ → ا */
const ALEF_VARIANTS = /[آأإٱٲٳ]/g;

/**
 * Fold a label or query to a form where equivalent spellings compare equal.
 * Decompose first so precomposed letters lose their marks with the rest.
 */
export function normalizeForSearch(value: string): string {
  return value
    .normalize("NFD")
    .replace(COMBINING, "")
    .replace(TATWEEL, "")
    .replace(ALEF_VARIANTS, "ا")
    .replace(/ى/g, "ي") // ى → ي
    .replace(/ة/g, "ه") // ة → ه
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

/** An empty query filters nothing, so the full list stays visible. */
export function matchesQuery(label: string, query: string): boolean {
  const q = normalizeForSearch(query);
  if (!q) return true;
  return normalizeForSearch(label).includes(q);
}
